import { render } from "./DeleteBlockModal.vue?vue&type=template&id=7be20fac&scoped=true&ts=true"
import script from "./DeleteBlockModal.vue?vue&type=script&lang=ts"
export * from "./DeleteBlockModal.vue?vue&type=script&lang=ts"

import "./DeleteBlockModal.vue?vue&type=style&index=0&id=7be20fac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be20fac"]])

export default __exports__